import * as types from './constants';

// Archive Assignment
export const archiveAssignmentRequest = data => (
  { type: types.ARCHIVE_ASSIGNMENT_REQUEST, payload: data }
);

export const archiveAssignmentDone = data => (
  { type: types.ARCHIVE_ASSIGNMENT_DONE, payload: data }
);

export const archiveAssignmentFailed = errors => (
  { type: types.ARCHIVE_ASSIGNMENT_FAILED, payload: errors }
);